export const isEmptyObj = (obj: Record<string, any>): boolean =>
  Object.keys(obj).length === 0 && obj.constructor === Object;

export const isEmptyArr = (arr: any[]): boolean => arr?.length === 0;
